/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './picker.user.tpl.html';

angular
  .module('shared.picker', [])
  /**
   * Controller for the Picker template.
   */
  .controller('PickerCtrl', function ($scope, $injector, NG_DATE_FORMATS) {
    var PickerStore, pickerStore;

    if ($scope.store) {
      pickerStore = $scope.store;
    } else {
      // Lookup the store provider for the picker.
      PickerStore = $injector.get($scope.storeName);
      pickerStore = new PickerStore();
    }

    $scope.format = NG_DATE_FORMATS.LONG;
    // Used in the batchrangepicker to show user which batch picker was invalid
    $scope.invalidSelectedDate = false;

    // forced to surround with quotes here so disable jshint rule.
    /* jshint -W109 */
    $scope.dateOptions = {
      'year-format': "'yy'",
      'starting-day': 1,
      'show-button-bar': true,
      'day-format': "'d'",
      maxMode: "'day'"
    };
    /* jshint +W109 */

    /**
     * Function tying next/previous button ttip and disabled state
     * to store.
     */
    $scope.nextTooltip = function () {
      return pickerStore.getNextTooltip();
    };

    $scope.previousTooltip = function () {
      return pickerStore.getPreviousTooltip();
    };

    $scope.previousDisabled = function () {
      return $scope.isPickerDisabled || pickerStore.previousDisabled();
    };

    $scope.nextDisabled = function () {
      return $scope.isPickerDisabled || pickerStore.nextDisabled();
    };

    /**
     * Handler for the previous button.
     */
    $scope.getPrevious = function () {
      $scope.showLoadingMask = true;
      pickerStore.getPrevious().then(
        function () {
          $scope.showLoadingMask = false;
        },
        function () {
          $scope.showLoadingMask = false;
        }
      );
    };

    /**
     * Handler for the next button.
     */
    $scope.getNext = function () {
      $scope.showLoadingMask = true;
      pickerStore.getNext().then(
        function () {
          $scope.showLoadingMask = false;
        },
        function () {
          $scope.showLoadingMask = false;
        }
      );
    };

    /**
     * Handler for the get latest button.
     */
    $scope.getLatest = function () {
      pickerStore.getLatest().then(function () {
        $scope.opened = false;
      });
    };

    /**
     * Tie Min and Max date values to store.
     */
    $scope.getMin = function () {
      return pickerStore.getMin();
    };

    $scope.getMax = function () {
      return pickerStore.getMax();
    };

    /**
     * Handler that is fired when a new date is selected.
     */
    $scope.dateChanged = function () {
      // user has selected a date in their localized calendar. we want to send the server the start of day (local timezone)
      // so that it can reliably search for any batches run between startOfDay + 1 day
      var startOfDay = moment($scope.dt).clone().startOf('day').toDate();
      pickerStore.getByDate(startOfDay);
    };

    /**
     * Returns the label to be used for the get latest button.
     *
     * @returns {String} - The label for the latest item.
     */
    $scope.getLatestLabel = function () {
      return pickerStore.latestLabel;
    };

    // Pass the scope the store for adding a listener for a new value loaded.
    pickerStore.setupDateTimeListener($scope);
  })
  .run(function ($templateCache) {
    // Taken from ui-bootstrap-tpls.js
    // Override the bootstrap popup template for the date picker in order to customize it for our needs.
    // Replaces the button at the bottom of the calendar with custom "Get Latest Backup"
    $templateCache.put(
      'template/datepicker/popup.html',
      '<ul class="dropdown-menu sbsf-bulk-restore-datepicker" ng-if="isOpen" style="display: block" ng-style="{display: (isOpen && \'block\')}" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">\n' +
        ' <li ng-transclude></li>\n' +
        ' <li class="sbsf-batch-picker-button-bar" ng-if="showButtonBar" style="padding:10px 9px 2px">\n' +
        '  <button type="button" class="btn btn-sbsf sbsf-batch-picker-latest-btn" ng-click="$parent.$parent.$parent.getLatest()">{{ $parent.$parent.$parent.getLatestLabel() }}</button>\n' +
        ' </li>\n' +
        '</ul>\n' +
        ''
    );

    // Custom template to use our own date picker icons (left & right arrow next to the date) and our own disabled date formatting.
    $templateCache.put(
      'template/datepicker/day.html',
      '<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n' +
        '  <thead>\n' +
        '    <tr>\n' +
        '      <th><button type="button" class="btn btn-default btn-sm pull-left" ng-click="move(-1)" tabindex="-1"><div class="sbsf-batch-picker-arrow sbsf-arrow-left"></div></button></th>\n' +
        '      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1" style="width:100%;"><strong>{{title}}</strong></button></th>\n' +
        '      <th><button type="button" class="btn btn-default btn-sm pull-right" ng-click="move(1)" tabindex="-1"><div class="sbsf-batch-picker-arrow sbsf-arrow-right"></div></button></th>\n' +
        '    </tr>\n' +
        '    <tr>\n' +
        '      <th ng-if="showWeeks" class="text-center"></th>\n' +
        '      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n' +
        '    </tr>\n' +
        '  </thead>\n' +
        '  <tbody>\n' +
        '    <tr ng-repeat="row in rows track by $index">\n' +
        '      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n' +
        '      <td ng-repeat="dt in row track by dt.date" class="text-center" role="gridcell" id="{{::dt.uid}}" ng-class="::dt.customClass">\n' +
        '        <button type="button" style="min-width:100%;" class="btn btn-default btn-sm" ng-class="{\'btn-info\': dt.selected, active: isActive(dt)}" ng-click="select(dt.date)" ng-disabled="dt.disabled" tabindex="-1"><span ng-class="{\'muted\': dt.secondary}">{{::dt.label}}</span></button>\n' +
        '      </td>\n' +
        '    </tr>\n' +
        '  </tbody>\n' +
        '</table>\n' +
        ''
    );
  })
  /**
   * The directive for the picker view. The storeName attribute should be
   * the name of the Store factory implementation to provide data to the picker.
   */
  .directive('picker', function () {
    return {
      templateUrl: 'shared/picker/picker.user.tpl.html',
      scope: {
        storeName: '@storeName',
        invalidDate: '&',
        store: '=',
        isPickerDisabled: '='
      },
      restrict: 'EA',
      controller: 'PickerCtrl'
    };
  });
